import { Roles } from 'hooks/useAuthRoles'
import { ApiVersion } from 'store/apiHeaders/types'

export interface AuthUser {
  roles: Roles[]
  companyId: number
  accountId: number
  sessionId: number
  apiVersion: ApiVersion
  permissions: string[]
}
export interface CharlieUser {
  userId: string
  permissions: string[]
  role: Roles
  intercomUserHash: string
  intercomId: string | null
  teamMemberId: string | null
  companyId: string
  companyName: string
  companyDomain: string
}

export interface AuthState {
  user: AuthUser | null
  charlieUser: CharlieUser | null
  jwt: string | null
  isLoading: boolean
  isAuthenticated: boolean
}

export interface AuthContextType extends AuthState {
  logout: (e: AuthErrorEnum) => void
  refreshCurrentToken: () => Promise<boolean>
  verifyCurrentToken: () => Promise<boolean>
}

export enum AuthErrorEnum {
  LOGOUT = 'logout',
  EXPIRED = 'expired',
  INVALID = 'invalid',
  SETUP = 'setup',
  ERROR = 'error',
}
